var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guarantee"},[_c('div',{staticClass:"guarantee__label"},[_c('IconGuarantee',{staticClass:"guarantee__icon"}),_c('span',{staticClass:"guarantee__text"},[_vm._t("default")],2)],1),_c('div',{staticClass:"guarantee__additional-block"},[_vm._t("additional")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }